import { useEffect } from "react";
import { useHistory } from "react-router";
import settings from "../../../utils/settings";

const ProfileEdit = () => {
  const history = useHistory();
  const { id } = settings();
  useEffect(() => {
    history.replace(`/merchant-users/${id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

export default ProfileEdit;
